// eslint-disable-next-line import/prefer-default-export
export const COUNCIL_EMAIL_TYPES = {
  ESTABLISH_COUNCIL: 'establishCouncil',
  REMIND: 'remind',
};
